module.exports = __webpack_public_path__ + "static/32import-59159aaf73e9d17f7e56b25e832d5535.png";